export default{
    msg:'',
    editar:{},
    lista:'',
    categorias:'',
    numero:'',
}